import { defineComponent as _defineComponent } from 'vue'
import { isAppUsing } from '@@/bits/flip'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostCommentsIcon',
  props: {
    commentIds: null,
    colorScheme: null,
    disable: { type: Boolean },
    usageContext: { default: 'postView' }
  },
  emits: ["show-comments-panel"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'show-comments-panel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { commentIds: [string | number], colorScheme: 'light' | 'dark', disable: boolean, usageContext: 'postView' | 'postExpandedView' }





const vEmitClickOnTouch = emitClickOnTouch

const surfaceContainerSizeStore = useSurfaceContainerSizeStore()
const { isContainerSmallerThanTabletPortrait } = storeToRefs(surfaceContainerSizeStore)

const surfaceCommentsStore = useCommentsStore()
const { commentEntities } = storeToRefs(surfaceCommentsStore)

const rootEl = ref<HTMLDivElement>()

const isUsedInPostExpandedView = computed<boolean>(() => props.usageContext === 'postExpandedView')

const iconSize = computed<number>(() => {
  if (isUsedInPostExpandedView.value) {
    return isContainerSmallerThanTabletPortrait.value ? 24 : 20
  }
  return 18
})

const commentsListLength = computed<number>(() => {
  if (isAppUsing('commentModeration')) {
    const publishedCommentIds = props.commentIds.filter(
      (id) => !commentEntities.value[id as number].is_awaiting_approval,
    )
    return publishedCommentIds.length
  }
  return props.commentIds.length
})

const showCommentsPanel = (): void => {
  if (props.disable) return
  if (rootEl.value?.closest('.surface-post')?.classList.contains('noclick')) {
    // Prevent popping out the comment panel when the post is being dragged
    return
  }
  emit('show-comments-panel')
}

return { __sfc: true,props, emit, vEmitClickOnTouch, surfaceContainerSizeStore, isContainerSmallerThanTabletPortrait, surfaceCommentsStore, commentEntities, rootEl, isUsedInPostExpandedView, iconSize, commentsListLength, showCommentsPanel, OzIcon }
}

})